<div class="layout-container font-regular" mat-app-background>
  <app-top-nav (sideNavToggled)="onToolbarMenuToggle()"></app-top-nav>
  <mat-sidenav-container class="sidenav-container" [style.marginTop.px]="toolBarHeight" [hasBackdrop]="hasBackdrop">
    <mat-sidenav #snav position="start" disableClose="true" role="navigation" class="sidenav mat-elevation-z10"
      [mode]="sideNavMode" [opened]="sideNavDefaultOpened"
      [ngStyle]="{'width.px': isExpanded ? openedWidth :  closedWidth}">
      <app-side-nav *ngIf="showFullMenu; else elseBlock"  (menuSelected)="closeSidebar()"></app-side-nav>
      <ng-template #elseBlock>
        <app-side-nav-closed></app-side-nav-closed>
      </ng-template>
    </mat-sidenav>
    <mat-sidenav-content role="rigion" id="sidenav-content"
      [ngStyle]="{'margin-left.px': isExpanded && !isMobile ? openedWidth :  closedWidth}">
      <main class="main-container">
        <router-outlet></router-outlet>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>